import { FONT, larger, light_smaller, COLOUR_SELECTED } from './Design.js';
import { GAME_VERSION,setNumberOfPlayers } from './State.js';

function resize(g) {
    var canvs = g.canvas, width = window.innerWidth, height = window.innerHeight;
    var wratio = width / height, ratio = canvs.width / canvs.height;
    if (wratio < ratio) {
        canvs.style.width = width + "px";
        canvs.style.height = (width / ratio) + "px";
    } else {
        canvs.style.width = (height * ratio) + "px";
        canvs.style.height = height + "px";
    }
}

const lineheight=28
const margin = 10
const herowidth = 32
const heroheight = 48

export class TutorialScene extends Phaser.Scene {

    constructor ()
    {
        super({ key: 'Tutorial', active: false });
    }

	setupBackground() {
		window.addEventListener('resize', () => resize(this.game));
		resize(this.game);
		//  A simple background for our game
		this.add.image(400, 300, 'sky');

		//  Here we create the ground.
		let erdboden = this.physics.add.staticGroup();
		//  Scale it to fit the width of the game (the original sprite is 400x32 in size)
		erdboden.create(400, 568, 'ground').setScale(2).refreshBody();

		this.add.text(750,580, 'v.' + GAME_VERSION, light_smaller)
	}

	create() {
        this.setupBackground();

		this.add.text(200, 100-lineheight*2, 'Bitte wähle einen Spielmodus', larger)
		this.singlePlayer2("E", 100, 100)
		this.multiPlayerVs("V", 450, 100)
		this.startBtn = this.add.image(this.game.canvas.width/2, 450,'start').setInteractive();
		this.startBtn.once('pointerup', ()=>this.start(), this);
		this.input.keyboard.on('keydown-ENTER', () =>this.start(), this);			
	}

	addRectangle = (x,y,width,height,borderWidth=2) => {
		return this.add.rectangle(x+(width/2)+(borderWidth/2), y+(height/2)+(borderWidth/2), width, height)
		.setStrokeStyle(borderWidth, 0xffffff)
	}

	singlePlayer2(startKey, x=0,y=0,width=250,height=300) {
		const addLineAndReturnNewY=(text,localx=x, localy=y)=>{
			this.add.text(localx+margin, localy+margin, text, FONT);
			return localy+lineheight
		}

		let clicky = this.addRectangle(x,y,width,height)
		this.clickySingleplayer = clicky;

		y = addLineAndReturnNewY('Einzelspieler:in ('+startKey+')')
		y = addLineAndReturnNewY('')

		this.add.image(x+margin+herowidth/2,y+margin+heroheight/2, 'heldin', 9+4)
		y+=heroheight+2*margin

		y = addLineAndReturnNewY('Steuerung')
		y = addLineAndReturnNewY('TASTATUR:')
		y = addLineAndReturnNewY('Pfeiltasten ←↑→ [LEER]')
		y = addLineAndReturnNewY('')
		y = addLineAndReturnNewY('Handy geht leider')
		y = addLineAndReturnNewY(' im Moment nicht')

		this.input.keyboard.on('keydown-'+startKey, () => this.selectSinglePlayer(), this);
		clicky.setInteractive().on('pointerup', () => this.selectSinglePlayer(), this);
	}

	selectSinglePlayer() {
		this.numberOfPlayers=1
	}

	selectMultiplayer() {
		this.numberOfPlayers=2
	}
	multiPlayerVs(startKey, x=0,y=0,width=250,height=300) {
		const addLineAndReturnNewY=(text,localx=x, localy=y)=>{
			this.add.text(localx+margin, localy+margin, text, FONT);
			return localy+lineheight
		}

		let clicky = this.addRectangle(x,y,width,height)

		this.clickyMultiplayer = clicky;
		y = addLineAndReturnNewY('Mehrspieler ('+startKey+')')
		y = addLineAndReturnNewY('Eins gegen Eins')

		this.add.image(x+margin+herowidth/2,y+margin+heroheight/2, 'heldin', 18+7)
		this.add.image(x+margin+herowidth*2,y+margin+heroheight/2, 'heldin', 0+2)

		y+=heroheight+2*margin

		y = addLineAndReturnNewY('Steuerung TASTATUR')
		y = addLineAndReturnNewY('Spieler:in 1')
		y = addLineAndReturnNewY('  Pfeiltasten ←↑→')
		y = addLineAndReturnNewY('Spieler:in 2')
		y = addLineAndReturnNewY('  WASD')
		
		this.input.keyboard.on('keydown-'+startKey, () => this.selectMultiplayer(), this);
		clicky
			.setInteractive()
			.on('pointerup', () => this.selectMultiplayer(), this);
	}

    singlePlayerTutorial()
    {
		var r1 = this.add.rectangle(100, 300, 200, 800, 0x6666ff);
		r1.setAlpha(.5)
		var r2 = this.add.rectangle(700, 300, 200, 800, 0x6666ff);
		r2.setAlpha(.5)
		var r3 = this.add.rectangle(400, 300, 400, 800, 0xfffff);
		r3.setAlpha(.5)

		var textY = 50;
		this.add.text(220, textY, 'Steuerung', FONT);
		textY+=30
		this.add.text(220, textY, 'Mit Tastatur:  Pfeiltasten ←↑→ LEERTASTE', FONT);
		textY+=30
		this.add.text(220, textY, 'Auf dem Handy:', FONT)
		textY+=30
		this.add.text(220, textY, '    ↙ Tippe die eingefärbten Bereiche ↘', FONT);
		textY+=30
		this.add.text(r1.x-90, textY, 'nach Links laufen', FONT);
		this.add.text(r2.x-90, textY, 'nach rechts laufen', FONT);
		this.add.text(r3.x-90, textY, 'hüpfen', FONT);

		textY+=60
		this.add.text(220, textY, 'Drücke ENTER ⏎ oder drücke auf START', FONT);
		textY+=30
		this.add.text(220, textY, 'um anzufangen.', FONT);
		textY += 100

		var start = this.add.image(this.game.canvas.width/2-40, textY,'start').setInteractive();
		textY+=start.height + 10;

		this.input.keyboard.once('keydown-ENTER', this.start, this);
		start.once('pointerup', this.start, this);

		return textY
    }

	update() {
		switch(this.numberOfPlayers) {
			case 1: 
				this.clickySingleplayer.setFillStyle(COLOUR_SELECTED)
				this.clickyMultiplayer.setFillStyle()
				this.startBtn.alpha = 1
				break;
			case 2:
				this.clickySingleplayer.setFillStyle()
				this.clickyMultiplayer.setFillStyle(COLOUR_SELECTED)
				this.startBtn.alpha = 1
				break;
			default: // noop
				this.startBtn.alpha = 0
		}
	}


    start = () => {
		if (!this.numberOfPlayers) return; // abort because nothing is selected
		setNumberOfPlayers(this.numberOfPlayers)
		this.scene.start('ChooseHeroScene')
	}
}